import {
    APPLICATION_LIST_REQUEST,
    APPLICATION_LIST_SUCCESS,
    APPLICATION_LIST_FAIL,
    APPLICATION_LIST_RESET,
    INVOICE_APPLICATION_LIST_REQUEST,
    INVOICE_APPLICATION_LIST_SUCCESS,
    INVOICE_APPLICATION_LIST_FAIL,
} from '../constants/applicationConstants'

export const applicationListReducer = (state = { applications: [] }, action) => {
    switch (action.type) {
        case APPLICATION_LIST_REQUEST:
            return { loading: true }
        case APPLICATION_LIST_SUCCESS:
            return { loading: false, applications: action.payload }
        case APPLICATION_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const invoiceApplicationListReducer = (state = { invoiceApplication: [] }, action) => {
    switch (action.type) {
        case INVOICE_APPLICATION_LIST_REQUEST:
            return { loading: true }
        case INVOICE_APPLICATION_LIST_SUCCESS:
            return { loading: false, invoiceApplication: action.payload }
        case INVOICE_APPLICATION_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}